import React from "react";
import { useFormData } from "@sp-state/useFormData";
import MultipleChoice from "./MultipleChoice";
import UniqueChoice from "./UniqueChoice";
import { QuestionAttribute } from "@components/BuilderComponents/SignupFormDrip/sfd-components/Form/sfd-helpers/sfd-form.type";

type QuestionAttributes = {
  questionAttributes: QuestionAttribute | null;
};

const QuestionInput = (props: QuestionAttributes) => {
  const { getQuestionValue } = useFormData(state => state);

  const questionAttributes = getQuestionValue(
    props?.questionAttributes?.questionName
  );

  if (!questionAttributes || !props?.questionAttributes) return null;

  return questionAttributes?.questionType === "multipleSelect" ? (
    <MultipleChoice questionAttributes={questionAttributes} />
  ) : (
    <UniqueChoice questionAttributes={questionAttributes} />
  );
};

export default QuestionInput;
